import UserService from "../services/UserService";

const RenderOnAuthenticated = ({realmId, children }) => {
    UserService.setRealm(realmId);

    return (UserService.isLoggedIn()) ? children : null;
}

export default RenderOnAuthenticated